
export const BOOL = [
    { value: "O", label: "Oui", id: "1" },
    { value: "N", label: "Non", id: "0" },
];

export const BOOL_LABEL = {
    "O": "Oui",
    "N": "Non"
};

export const AGE = [
    { value: "A", label: "Adulte" },
    { value: "T", label: "Ado" },
    { value: "C", label: "Enfant" },
    { value: "B", label: "Bébé" },
];

export const AGE_LABEL = {
    "A": "Adulte",
    "T": "Ado",
    "C": "Enfant",
    "B": "Bébé"
};

export const GENDER = [
    { value: "F", label: "Femme" },
    { value: "M", label: "Homme" },
];

export const GENDER_LABEL = {
    "F": "Femme",
    "M": "Homme"
};

export const GAME_TYPE = [
    { value: "QCM", label: "QCM" },
    { value: "LOCK", label: "Cadenas" },
];

export const GAME_TYPE_LABEL = {
    "QCM": "QCM",
    "LOCK": "Cadenas",
};

export const GAME_MODE = [
    { value: "S", label: "Solo" },
    { value: "T", label: "Equipe" },
];

export const GAME_MODE_LABEL = {
    "S": "Solo",
    "T": "Equipe",
};

export const GAME_PROGRESS_MODE = [
    { value: "SYNC", label: "Synchrone" },
    { value: "UNSYNC", label: "Asynchrone" },
]

export const GAME_PROGRESS_MODE_LABEL = {
    "SYNC": "Synchrone",
    "UNSYNC": "Asynchrone"
}

export const ITEM_TYPE = [
    { value: "I", label: "Info" },
    { value: "Q", label: "QCM" },
    { value: "L", label: "Question libre" },
    { value: "R", label: "Résultat" },
    { value: "F", label: "Finale" },
];

export const ITEM_TYPE_LABEL = {
    "I": "Info",
    "Q": "QCM",
    "L": "Question libre",
    "R": "Résultat",
    "F": "Finale",
};

export const ITEM_RESPONSE = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "D", label: "D" },
];

export const ITEM_RESPONSE_LABEL = {
    "A": "A",
    "B": "B",
    "C": "C",
    "D": "D",
};
